.overview {
  grid-column: 1 / -1;
  min-width: 0;
}

.metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--gap);
  margin: 0;
}

.metric {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
}

/* Small caps, muted: the same rank as KpiTile's label. */
.metric dt {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
  letter-spacing: 0.06em;
  line-height: 1.3;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}

/* The figure is the largest thing and full ink. It is a count of decisions or records, never an
   emission, so it is never coloured. */
.metric dd {
  margin: 4px 0 2px;
  color: var(--ink);
  font-size: var(--t-kpi);
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.03em;
  font-variant-numeric: lining-nums tabular-nums;
  overflow-wrap: anywhere;
}

.note {
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.overview > p {
  margin: 10px 0 0;
}

.skeleton {
  display: block;
  width: 3ch;
  height: 1.2em;
  border-radius: 4px;
  background: var(--panel-3);
}

@media (width <= 900px) {
  .metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
